import { Card, Stack, type StackProps, Text, VStack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';

type Props = {
  message: string;
  submessage?: string;
  testID?: string;
};

const WideBanner = ({ message, submessage, testID, ...rest }: Props & StackProps) => {
  return (
    <VStack
      background="$surface.container"
      display="flex"
      flexDirection="row"
      borderStyle="solid"
      borderWidth={1}
      borderColor="$neutral.20"
      borderLeftWidth={0}
      borderRightWidth={0}
      padding="$4"
      marginBottom="$2"
      marginTop="$3"
      testID={`${testID}-banner-wrapper`}
      {...rest}
      marginHorizontal={-14}
    >
      <VStack>
        <IconValidationInvalid color="$support.danger.surfaceOnColorAlt" />
      </VStack>
      <VStack marginLeft="$2" display="flex" flex={1}>
        <Text
          testID={`${testID}-banner-message`}
          color="$text.100"
          fontSize="$bodyBase.default"
          fontWeight="$bodyBase.default"
        >
          {message}
        </Text>
        <Text
          testID={`${testID}-banner-submessage`}
          color="$text.100"
          fontSize="$bodyBase.default"
          fontWeight="$bodyBase.strong"
        >
          {submessage}
        </Text>
      </VStack>
    </VStack>
  );
};

const Banner = ({ message, submessage, testID }: Props) => {
  return (
    <Card testID={testID}>
      <Stack flexDirection="row">
        <VStack>
          <IconValidationInvalid color="$support.danger.surfaceOnColorAlt" />
        </VStack>
        <VStack marginLeft="$2" display="flex" flex={1}>
          <Text type="$bodyBase.default" textAlign="left" testID={`${testID}-banner-message`}>
            {message}
          </Text>
          {submessage ? (
            <Text type="$bodyBase.strong" textAlign="left" testID={`${testID}-banner-submessage`}>
              {submessage}
            </Text>
          ) : undefined}
        </VStack>
      </Stack>
    </Card>
  );
};

export { Banner, WideBanner };
